<template>
  <div class="relative min-h-screen">
    <img
      src="/images/mobile-warning.webp"
      alt="Mobile"
      class="absolute w-full h-full object-cover"
    />
    <div class="relative z-10 py-16 h-screen">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
